import { GlobalAxios } from "../axios/axios-config";
import {
  INewTicketServiceMessage,
  ITicketServiceMessage,
} from "../models/ticket-service-message";
import { TTicketServiceMessageForm } from "../pages/4uChatbot/RegistrationsAndRules/TicketServiceMessage/TicketServiceMessageForm/TicketServiceMessageSchema";

const TICKET_SERVICE_MESSAGE_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketServiceMessage/";

export class TicketServMessageService {
  create = (item: INewTicketServiceMessage) => {
    return GlobalAxios.post(TICKET_SERVICE_MESSAGE_ROUTE + "CreateItem", item);
  };

  getItemById = (id: string) => {
    return GlobalAxios.get<TTicketServiceMessageForm>(
      TICKET_SERVICE_MESSAGE_ROUTE + id
    );
  };

  updateItemById = ({
    item,
    id,
  }: {
    item: ITicketServiceMessage;
    id: string;
  }) => {
    return GlobalAxios.put(TICKET_SERVICE_MESSAGE_ROUTE + id, item);
  };
}

export default TicketServMessageService;
